export default __webpack_public_path__ + "static/media/person.52b0525b.svg";